import { render } from "./Vjs.vue?vue&type=template&id=71b93d5e&scoped=true"
import script from "./Vjs.vue?vue&type=script&lang=js"
export * from "./Vjs.vue?vue&type=script&lang=js"

import "./Vjs.vue?vue&type=style&index=0&id=71b93d5e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b93d5e"]])

export default __exports__